import { Component, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-pre-qual',
  templateUrl: './pre-qual.component.html',
  styleUrl: './pre-qual.component.css'
})
export class PreQualComponent {
  @Output() preQualResp = new EventEmitter<any>();

  preQualForm: FormGroup;
  emitObj: any = null;
  customerType: any;
  preQualType: any;
  failedPQ: any;

  verifyGCSpinner: boolean = false;
  nextLoading: boolean = false;

  constructor(
    private data: DataserviceService,
    private message: NzMessageService
  ) {
    
    this.preQualForm = new FormGroup({
      hasPreQualCode: new FormControl(false, []),
      preQualCode: new FormControl(null, []),
      ssn: new FormControl(null, [])
    })

    this.preQualForm.get('hasPreQualCode')?.valueChanges
    .subscribe(val => {
      if(val) {
        this.preQualForm.get('preQualCode')?.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(12)]);
        this.preQualForm.get('ssn')?.setValidators([Validators.required]);
      }else {
        this.preQualForm.get('preQualCode')?.setValidators(null);
        this.preQualForm.get('ssn')?.setValidators(null);
        this.preQualForm.patchValue({ preQualCode: null, ssn: null }, { emitEvent: false });
        this.resetPreQualState();
      }
      this.preQualForm.get('preQualCode')?.updateValueAndValidity();
      this.preQualForm.get('ssn')?.updateValueAndValidity();
    })

  }

  doPreQual() {
    this.verifyGCSpinner = true;
    this.resetPreQualState();
    const id = this.message.loading('Checking gift card code...', { nzDuration: 0 }).messageId;

    const obj = {
      approvalCode: this.preQualForm.get('preQualCode')?.value,
      social:  String(this.preQualForm.get('ssn')?.value || '').replace(/\D/g, '')
    };

    this.data.postDataNoBodyDotBody(obj, 'qualify/prequal')
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res?.result == 'success') {
            this.handlePreQualSuccess(res, id);

          }else {
            this.failedPQ = 'The gift card code could not be applied. It may be invalid or already used. If you believe the code is valid, please try entering it again.'
            setTimeout(() => {
              this.verifyGCSpinner = false;
              this.message.remove(id);
            }, 250)
          }
        },
        error: (err: any) => {
          alert('There was an error when checking the gift card code')
          setTimeout(() => {
            this.verifyGCSpinner = false;
            this.message.remove(id);
          }, 250)
        }
      })
  }

  handlePreQualSuccess(pq: any, id: any) {

    this.emitObj = {
      preQual: true,
      conversationId: pq?.conversationResponse?.getConversationIdResult,
      leadId: pq?.qualResponse?.LeadId,
      customerInfo: {
        firstName: pq?.qualResponse?.Name?.FirstName,
        lastName: pq?.qualResponse?.Name?.LastName,
        address: pq?.qualResponse?.ServiceAddress?.Address?.LineOne,
        city: pq?.qualResponse?.ServiceAddress?.Address?.City,
        state: pq?.qualResponse?.ServiceAddress?.Address?.State,
        zip: pq?.qualResponse?.ServiceAddress?.Address?.Zip
      },
      qual: {ssn:  this.preQualForm.get('ssn')?.value},
      promoId: pq?.qualResponse?.QualifiedPromotions?.Promotion?.[0].PromotionID
    }

    this.customerType = 'Gift card verified';
    this.preQualType = pq?.qualResponse?.GiftValue;

    setTimeout(() => {
      this.verifyGCSpinner = false;
      this.message.remove(id);
    }, 250)

  }

  resetPreQualState() {
    this.emitObj = null;
    this.customerType = null;
    this.preQualType = null;
    this.failedPQ = null;
    this.nextLoading = false;
  }

  nextStep() {
    if (this.nextLoading) {
      return;
    }
    this.nextLoading = true;
    const payload = this.emitObj && this.emitObj.preQual ? this.emitObj : null;
    this.preQualResp.emit(payload);
  }

}
